import PanelLeftAdministrativeHistory from "./panel-administrative-left-history";
import PanelLeftAdministrativeSuscriptions from "./panel-administrative-left-suscriptions";
import PanelLeftAdministrativeSuspensions from "./panel-administrative-left-suspensions";

const PanelLeftAdministrative = (props) => {
  return (
    <div
      className="d-flex flex-column gap-2 align-items-center"
      style={{
        width: "40%",
        borderRadius: "10px",
        height: "100%",
      }}
    >
      <div
        className="d-flex gap-2"
        style={{ height: "20%", minHeight: "115px", width: '90%' }}
      >
        <PanelLeftAdministrativeSuscriptions />
        <PanelLeftAdministrativeSuspensions />
      </div>
      <div className="w-100" style={{ height: "80%" }}>
        <PanelLeftAdministrativeHistory />
      </div>
    </div>
  );
};
export default PanelLeftAdministrative;
